<template id="mdm-form-page">
  <section>
    <div>
      <div class="m-1">
        <div class="card">
          <div class="card-header text-left d-flex justify-content-between align-items-center"
               style="gap: 5px;margin: 3px">
            <div>
              <i class="fa fa-file"></i> {{ formTitle }}
            </div>
            <div class="flex-grow-0" style="min-width: 200px; max-width: 300px;">
              <div class="input-group">
                <input type="text"
                       v-model="filterValue"
                       placeholder="Search..."
                       class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="card-body">

            <!--Filters-->
            <div class="d-flex flex-wrap align-items-center rounded" style="margin: 3px;gap: 5px">
              <!-- Removed template tag and moved key to the actual div -->
              <div v-for="filter in dimSelectDpValues"
                   :key="`filter-${filter.key}`"
                   class="flex-grow-1"
                   style="min-width: 150px; max-width: 200px;">
                <label class="form-label small mb-0">{{ filter.displayName }}</label>
                <v-select multiple v-bind:key="filter.key" v-model="selectVal[filter.key]"
                          :options="options[filter.key]">
                  <option>All</option>
                  <option style="z-index: 100" :value="option" v-for="option in options[filter.key]" :key="option">{{
                      option
                    }}
                  </option>
                </v-select>
              </div>
            </div>
            <!--table-->
            <div class="grid-container">
              <div class="table-responsive" :style="{ height:$store.state.bannerStatus ? '71vh' : '73vh'}"
                   style="position: relative; overflow-y: auto;">
                <table class="table table-bordered">
                  <thead class="thead-dark" style="position: sticky; top: 0; z-index: 1">
                  <tr class="text-center">
                    <th>Action
                      <a><i class="fa-sort"></i></a>
                    </th>
                    <th v-for="(col, index) in columns" v-bind:key="index"
                        :style="col === 'S.No' ? { width: '120px' } : {}">
                      {{ col }}
                      <a href="#" @click="sortBy(Rcolumns[index])">
                        <i class="fa"
                           v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' "
                           v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]"></i>
                      </a>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(rowd,index) in paginatedItems">
                    <tr v-bind:key="index">
                      <td class="text-center">
                        <div class="btn-group">
                          <button v-if="rowd.syspk !== editableId"
                                  class="btn btn-sm btn-outline-primary"
                                  v-on:click="showRow(rowd.syspk)">
                            <i class="fa fa-plus"></i>
                          </button>
                          <button v-if="rowd.syspk !== editableId"
                                  class="btn btn-sm btn-outline-warning" size="sm"
                                  v-on:click="edit(rowd.syspk)">
                            <i class="fa fa-edit"></i>
                          </button>
                          <button v-if="showInputfield && rowd.syspk === editableId"
                                  class="btn btn-sm btn-outline-success custom-padding"
                                  v-on:click="validateEditRow(rowInsert)"
                          >
                            <i class="fas fa-check"></i>
                            <!--<i class="fa fa-save"></i>-->
                          </button>

                          <button v-if="showInputfield && rowd.syspk === editableId" class="btn btn-sm btn-outline-danger"
                                  v-on:click="hideR(rowd)"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </td>
                      <td :class="{
                        'text-right' : col.startsWith('rm'),
                        'text-left' : col.startsWith('rd') || col.startsWith('rr'),
                        'text-danger':rowd['rm7']>40,
                        'multi-line-cell': true,
                        'textarea-cell': columnsInfo[i]['fieldValidationType'] === 'textarea'
                      }"
                          v-for="(col,i) in Rcolumns" v-bind:key="col">{{ rowd[col] }}
                      </td>
                    </tr>
                    <template v-if="showInputfield && rowd.syspk == editableId">
                      <!--                        <tr :key="rowd.index"><h6>Edit Record</h6>-->
                      <!--                           <button class="btn btn-sm btn-outline-primary"-->
                      <!--                                    v-on:click="validateEditRow(rowd)"-->
                      <!--                                    v-b-tooltip.hover-->
                      <!--                                    title="Validate">-->
                      <!--                               <i class="fas fa-tasks"></i>-->
                      <!--                                &lt;!&ndash;<i class="fa fa-save"></i>&ndash;&gt;-->
                      <!--                           </button>-->

                      <!--                            <button class="btn btn-sm btn-danger" v-on:click="hideR(rowd)"-->
                      <!--                                    v-b-tooltip.hover-->
                      <!--                                    title="Cancel">-->
                      <!--                                <i class="fa fa-window-minimize"></i>-->
                      <!--                            </button>-->

                      <!--                        </tr>-->
                      <tr :key="rowd.index" style="background-color: #FFF9DF;font-size: 12px;">
                        <!--<tr v-bind:key="index+'i'"  v-if="false">-->
                        <th style="background-color:rgb(251, 235, 196)"></th>
                        <th v-for="(col, index) in columns" v-bind:key="index"
                            style="background-color: rgb(251, 235, 196)">
                          <label>{{ col }}</label>
                          <input v-if="columnsInfo[index]['inputFieldType']!=='Select Only'
                                 && columnsInfo[index]['fieldValidationType'] !== 'date'
                                && columnsInfo[index]['fieldValidationType'] !== 'email'
                                && columnsInfo[index]['fieldValidationType'] !== 'number'
                                && columnsInfo[index]['fieldValidationType'] !== 'phoneNumber'
                                && columnsInfo[index]['fieldValidationType'] !== 'textarea'"
                                 type="text"
                                 :value="transformValue(rowInsert[Rcolumns[index]], columnsInfo[index]['requiredCase'])"
                                 @input="updateValue($event, Rcolumns[index], columnsInfo[index]['requiredCase'])"
                                 class="form-control"
                                 :disabled="columnsInfo[index]['fieldIsEditable']">

                          <textarea
                              v-if="columnsInfo[index]['fieldValidationType'] === 'textarea'"
                              v-model="rowInsert[Rcolumns[index]]"
                              class="form-control auto-expand-textarea"
                              :disabled="columnsInfo[index]['fieldIsEditable']"
                              @input="autoExpand"
                          ></textarea>

                          <div class="date-picker-container"
                               v-if="columnsInfo[index]['fieldValidationType'] === 'date'">
                            <date-picker
                                v-model="rowInsert[Rcolumns[index]]"
                                value-type="DD/MM/YYYY"
                                format="DD/MM/YYYY"
                                type="date"
                                placeholder="Select date"
                                :clearable="false"
                                style="width: 150px"
                                @input="date($event, Rcolumns[index])"
                                :disabled="columnsInfo[index]['fieldIsEditable']"
                            ></date-picker>
                          </div>

                          <validation-provider v-if="columnsInfo[index]['fieldValidationType']==='email'"
                                               rules="required|email"
                                               v-slot="{ errors }">
                            <input :type="columnsInfo[index]['fieldValidationType']"
                                   @change="handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowInsert[Rcolumns[index]])"
                                   v-model="rowInsert[Rcolumns[index]]"
                                   class="form-control"
                                   :disabled="columnsInfo[index]['fieldIsEditable']"
                            >
                            <span v-if="errors.length" class="help is-danger">
                              {{ errors[0] }}
                            </span>
                          </validation-provider>

                          <validation-provider
                              v-if="columnsInfo[index]['fieldValidationType'] === 'number'"
                              rules="required|numeric"
                              v-slot="{ errors }"
                          >
                            <input
                                type="text"
                                @input="handleNumberInput($event, Rcolumns[index])"
                                v-model="rowInsert[Rcolumns[index]]"
                                class="form-control"
                                :disabled="columnsInfo[index]['fieldIsEditable']"
                            >
                            <span v-if="errors.length" class="help is-danger">
                              {{ errors[0] }}
                            </span>
                          </validation-provider>

                          <validation-provider
                              v-if="columnsInfo[index]['fieldValidationType'] === 'phoneNumber'"
                              rules="required|indianPhone"
                              v-slot="{ errors }"
                          >
                            <input
                                type="tel"
                                @input="handleIndianPhoneNumberInput($event, Rcolumns[index])"
                                v-model="rowInsert[Rcolumns[index]]"
                                class="form-control"
                                placeholder="Enter 10-digit phone number"
                                maxlength="10"
                                :disabled="columnsInfo[index]['fieldIsEditable']"
                            >
                            <span v-if="errors.length" class="help is-danger">
                                  {{ errors[0] }}
                            </span>
                          </validation-provider>
                          <!--                            v-if="columnsInfo[index]['inputFieldType']=='Enter Only'"-->
                          <v-select
                              v-if="(col!=='Mfg. Name' && col!=='Brand Name') && columnsInfo[index]['inputFieldType']==='Select Only'"
                              :options="listboxData[Rcolumns[index]]"
                              v-model="rowInsert[Rcolumns[index]]"
                              :disabled="columnsInfo[index]['fieldIsEditable']"
                          >
                            <option>Select State</option>
                            <option v-for="rl in listboxData[Rcolumns[index]]" :key="rl">{{ rl }}</option>
                          </v-select>
                        </th>
                      </tr>
                    </template>
                    <template v-if="showInput && rowd.syspk === savetableId">
                      <!--                        <tr :key="rowd.index"><h6>New Record</h6>-->
                      <!--                            <button class="btn btn-sm btn-outline-primary"-->
                      <!--                                    v-on:click="validateInsertRow(rowEdit)"-->
                      <!--                                    v-b-tooltip.hover-->
                      <!--                                    title="Validate">-->
                      <!--                                <i class="fas fa-tasks"></i>-->
                      <!--                            </button>-->

                      <!--                            <button class="btn btn-sm btn-danger" v-on:click="hideR(rowd)"-->
                      <!--                                    v-b-tooltip.hover-->
                      <!--                                    title="Cancel">-->
                      <!--                                <i class="fa fa-window-minimize"></i>-->
                      <!--                            </button>-->
                      <!--                        </tr>-->
                      <tr :key="rowd.index" style="background-color: rgb(255, 253, 247);font-size: 12px">
                        <th style="background-color: rgb(231, 255, 231);font-size: 12px">
                          <button v-if="showInput && rowd.syspk === savetableId" class="btn btn-sm btn-outline-success custom-padding"
                                  v-on:click="validateInsertRow(rowEdit)"
                          >
                            <i class="fas fa-check"></i>
                          </button>

                          <button v-if="showInput && rowd.syspk === savetableId" class="btn btn-sm btn-outline-danger"
                                  v-on:click="hideR(rowd)"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </th>
                        <th v-for="(col, index) in columns" :key="index"
                            style="background-color: rgb(231, 255, 231);font-size: 12px">
                          <label>{{ col }}
                            <span v-if="columnsInfo[index]['fieldIsNullable']==='N'" class="text-danger">*</span>
                          </label>

                          <!-- Regular input fields (non-email) -->
                          <input
                              v-if="columnsInfo[index]['inputFieldType']==='Enter Only' &&
                              columnsInfo[index]['fieldValidationType'] !== 'email' &&
                              columnsInfo[index]['fieldValidationType'] !== 'date' &&
                              columnsInfo[index]['fieldValidationType'] !== 'number' &&
                              columnsInfo[index]['fieldValidationType'] !== 'phoneNumber' &&
                              columnsInfo[index]['fieldValidationType'] !== 'textarea'"
                              :type="columnsInfo[index]['fieldValidationType']"
                              @input="updateInsertValue($event, Rcolumns[index], columnsInfo[index]['requiredCase'])"
                              @change="handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowEdit[Rcolumns[index]])"
                              required
                              :name="columnsInfo[index]['fieldValidationType']"
                              :value="rowEdit[Rcolumns[index]]"
                              class="form-control"
                              :disabled="col=='S.No'"
                          >

                          <textarea
                              v-if="columnsInfo[index]['fieldValidationType'] === 'textarea'"
                              v-model="rowEdit[Rcolumns[index]]"
                              class="form-control auto-expand-textarea"
                              @input="autoExpand"
                          ></textarea>
                          <!-- Date input field with validation -->
                          <ValidationProvider
                              v-if="columnsInfo[index]['inputFieldType']=='Enter Only' && columnsInfo[index]['fieldValidationType'] === 'date'"
                              :name="col"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <div class="date-picker-container">
                              <date-picker
                                  v-model="rowEdit[Rcolumns[index]]"
                                  value-type="DD/MM/YYYY"
                                  format="DD/MM/YYYY"
                                  type="date"
                                  placeholder="Select date"
                                  :clearable="false"
                                  style="width: 150px"
                                  @input="date($event, Rcolumns[index])"
                              ></date-picker>
                              <span v-if="errors.length" class="help is-danger">
                                 {{ errors[0] }}
                            </span>
                            </div>
                          </ValidationProvider>

                          <!-- Email field with VeeValidate validation -->
                          <validation-provider v-if="columnsInfo[index]['fieldValidationType']==='email'"
                                               rules="required|email"
                                               v-slot="{ errors }">
                            <input :type="columnsInfo[index]['fieldValidationType']"
                                   @change="handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowEdit[Rcolumns[index]])"
                                   v-model="rowEdit[Rcolumns[index]]"
                                   class="form-control"
                            >
                            <span v-if="errors.length" class="help is-danger">
                              {{ errors[0] }}
                            </span>
                          </validation-provider>

                          <validation-provider
                              v-if="columnsInfo[index]['fieldValidationType'] === 'number'"
                              rules="required|numeric"
                              v-slot="{ errors }"
                          >
                            <input
                                type="text"
                                @input="handleNumberInput($event, Rcolumns[index])"
                                v-model="rowEdit[Rcolumns[index]]"
                                class="form-control"
                            >
                            <span v-if="errors.length" class="help is-danger">
                              {{ errors[0] }}
                            </span>
                          </validation-provider>

                          <validation-provider
                              v-if="columnsInfo[index]['fieldValidationType'] === 'phoneNumber'"
                              rules="required|indianPhone"
                              v-slot="{ errors }"
                          >
                            <input
                                type="tel"
                                @input="handleIndianPhoneNumberInput($event, Rcolumns[index])"
                                v-model="rowEdit[Rcolumns[index]]"
                                class="form-control"
                                placeholder="Enter 10-digit phone number"
                                maxlength="10"
                            >
                            <span v-if="errors.length" class="help is-danger">
                                  {{ errors[0] }}
                            </span>
                          </validation-provider>

                          <!-- GSTIN Validation Message -->
                          <span v-if="columnsInfo[index]['fieldValidationType']=='GSTINValidate'">
                            <div>{{ message }}</div>
                            <div>{{ name }}</div>
                          </span>

                          <!-- v-select components (unchanged) -->
                          <v-select
                              v-if="(col!=='Mfg. Name' && col!=='Brand Name') && columnsInfo[index]['inputFieldType']=='Select Only'"
                              :options="listboxData[Rcolumns[index]]"
                              v-model="rowEdit[Rcolumns[index]]"
                          >
                            <option>Select State</option>
                            <option v-for="rl in listboxData[Rcolumns[index]]" :key="rl">{{ rl }}</option>
                          </v-select>

                          <!-- Other v-select components remain unchanged -->
                          <!-- ... -->
                        </th>
                      </tr>
                    </template>

                  </template>
                  </tbody>
                </table>
              </div>
              <!-- Pagination controls -->
              <div v-if="filteredItems.length > 500" style="justify-content: center; display:flex; width:100%;">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    align="center"
                    aria-controls="my-table"
                ></b-pagination>
                <p class="sm-2 text-primary" style="margin-left: 10px;margin-top: 5px">No.of Rows: {{ rows }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-xl" size="xl" ref="validate-update-row-box" @ok="updateRecord()" :title="formTitle">

      <b-form-group :label="rowd['syspk']==20?'Check the rows for duplication':'No Matching Record found'">
        <!--<b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                required
        ></b-form-input>-->
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="thead-dark">
            <tr class="text-center">

              <th v-for="(col, index) in columns" v-bind:key="index">
                {{ col }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>

              <td style="color:blue" v-for="(col, index) in columns" v-bind:key="index">
                {{ rowd[Rcolumns[index]] }}

              </td>
            </tr>
            <template v-if="rowd['syspk']==20">
              <tr v-for="er in 2" v-bind:key="er">

                <td style="color:darkgoldenrod" v-for="(col, index) in columns" v-bind:key="index">
                  {{ rowd[Rcolumns[index]] }}
                </td>


              </tr>
            </template>

            </tbody>
          </table>

        </div>
      </b-form-group>

    </b-modal>
    <b-modal id="modal-xl" size="xl" ref="validate-insert-row-box" @ok="insertRecord()" ok-title="Accept"
             :title="formTitle">

      <b-form-group
          :label="dedupData.length>0?'Check the rows for duplication':'No Possible Duplicate Record found. Please validate and accept for insertion'">
        <!--<b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                required
        ></b-form-input>-->
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="thead-dark">
            <tr class="text-center">

              <th v-for="(col, index) in columns" v-bind:key="index">
                {{ col }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>

              <td style="color:blue" v-for="(col, index) in columns" v-bind:key="index">
                {{ rowdIns[Rcolumns[index]] }}

              </td>
            </tr>
            <template v-if="dedupData.length>0">
              <tr v-for="er in dedupData" v-bind:key="er">

                <td style="color:darkgoldenrod" v-for="(col, index) in columns" v-bind:key="index">
                  {{ er[Rcolumns[index]] }}
                </td>


              </tr>
            </template>

            </tbody>
          </table>

        </div>
      </b-form-group>

    </b-modal>
    <b-modal ref="success-box" :hide-footer="true" :title="formTitle" cancel-disabled ok-disabled>
      <b-form-group label="">
        <h4 style="color:darkblue">Record Added Successfully.</h4>
      </b-form-group>
    </b-modal>
    <div>
      <!-- Your existing UI -->
      <modal
          v-if="showErrorModal"
          :isVisible="showErrorModal"
          @close="showErrorModal = false"
          :title="title"
      >
        <!--        <span>Selected option is not supported.</span>-->
      </modal>
    </div>
  </section>

</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import {ValidationProvider, extend} from 'vee-validate';
import {required, email, numeric} from 'vee-validate/dist/rules';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Modal from "@/components/Modal.vue";
import {markRaw} from "vue"


// Add the required rule
extend('email', email);
extend('required', required);
extend('indianPhone', {
  validate: value => /^[6-9][0-9]{9}$/.test(value),  // Must start with 6-9
  message: 'Enter a valid Phone Number'
});

// Extend the numeric rule
extend('numeric', {
  ...numeric,
  message: 'This field must contain only numbers'
});


export default {
  name: 'simple-report-page',
  components: {Modal, ValidationProvider, DatePicker},
  data: function () {
    return {
      title: "",
      showErrorModal: false,
      rowInsert: [],
      dateErrors: {},
      errors: {},
      emailField: '',
      showInputfield: '',
      editableId: [],
      showInput: '',
      savetableId: [],
      hideRow: [],
      rowd: [],
      rowdIns: [],
      columnsInfo: [],
      rowEdit: [],
      listboxData: [],
      dedupData: [],
      mfgNameList: [],
      brandNameList: [],

      message: '',
      name: '',


      output: [],
      formTitle: '',
      formMessage: '',
      columns: [],
      filters: [],
      keys: [],
      rowsdata: [],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },
      currentPage: 1,
      perPage: 500,
    }
  },
  created: function () {
    //this.loadCustomerSales()
    this.loadReportConfig()
    this.listenToRouter()
  },
  watch: {
    filteredItems() {
      // Reset to first page if filters change
      this.currentPage = 1
    }
  },
  computed: {
    rows() {
      return this.filteredItems.length
    },
    paginatedItems() {
      // If less than 1000 records, just return all
      if (this.filteredItems.length <= this.perPage) {
        return this.filteredItems
      }
      let start = (this.currentPage - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      return Object.keys(this.rowsdata[0])
    },
    "orderedData": function () {
      let result = this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    mfgName() {
      return (key1) => {
        console.log("mfg code passed", key1, this.mfgNameList.filter(f => f.c_mfac_code == 'MF0001')[0].c_mfac_name)
        if (key1) {
          return [this.mfgNameList.filter(f => f.c_mfac_code == key1)[0].c_mfac_name]
        } else
          return null

      }
    },
    brandName() {
      return (key1) => {
        console.log("mfg code passed", key1)
        if (key1) {
          return [this.brandNameList.filter(f => f.c_brand_code == key1)[0].c_brand_name]
        } else
          return null

      }
    },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {

          if (this.selectVal[key]) {
            // console.log("filter ", this.selectVal,this.selectVal[key].length==0)
            keep =
                keep &&
                (this.selectVal[key].length == 0 ||
                    //item[key] === this.selectVal[key]); // true && (false ||
                    this.selectVal[key].includes(item[key])); // true && (false ||
          }

        });

        return keep;
      });
      // let result = this.rowsdata;
      if (this.filterValue) {
        /* Filters the report Data based on the entered value in the generic search box
           loop over the keys of the inner object and use Array.some()
           It will work for any number of keys of any name so no need to get depend on the keys
           to get the match of the searched text use includes()
           to make the search non case sensitive use toLowerCase()
           to avoid NULL values in filtering excluded null values by taking !=Null and with && operator
           Numeric values gave obj[key].includes is not function error so converted them to string using toString()
        */
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))
        );


      }
      return markRaw(_.orderBy(result, this.sortKey, this.sortOrder))
    },
    getValues() {
      return (key1, x) => {
        // console.log("getValues ====> item", key1, x)
        var filteredData = this.example.filter((item) => {

          for (let kkk in x) { // loop over the keys of x
            //console.log("getValues >>>> ",kkk)

            if (x[kkk] && x[kkk].length > 0) { //check the value of each key is undefined/NULL or not
              //  console.log("getValues ,,,,",x[kkk],x[kkk].includes("All"))

              if (!x[kkk].includes('All')) { // check the value of the key doesn't contains All as a value
                // console.log("getValues,,,,", item[kkk], x[kkk])
                if (item[kkk] === undefined || !x[kkk].includes(item[kkk])) {

                  return false;
                }
              }
            }
            //  console.log("not entered if")
          }
          return true;
        });

        var whereClause = '1==1 '
        for (let kkk in x) {
          // console.log("kkk x ",kkk, x,x[kkk],whereClause + ' && ! x[kkk]'+ '.includes("item["' + kkk + '"]) ')
          if (x[kkk] && x[kkk].length > 0 && x[key1] && x[key1].length > 0) { //check the value of each key is undefined/NULL or not
            if (kkk == key1) { // check if it is for the passed key then make it as not in
              whereClause = whereClause + ' && !x["' + kkk + '"]' + '.includes(item["' + kkk + '"]) '
            } else { //if not append and clause
              whereClause = whereClause + ' && x["' + kkk + '"]' + '.includes(item["' + kkk + '"])'
            }

          } else if (x[key1] && x[key1].length <= 0) {
            whereClause = whereClause + " && 1==2 "
          }
        }
        var example1 = _.clone(this.example)

        var invertFilteredData = example1.filter((item) => {

          if (eval(whereClause) && item) {
            return true;
          } else {
            return false
          }

        })
        var firstArray = _.uniq(filteredData.map(kv => kv[key1]))
        var secondArray = []
        if (x[key1] && x[key1].length > 0) {
          secondArray = _.uniq(invertFilteredData.map(kv => kv[key1]))
        }

        var unionArray = _.union(firstArray, secondArray)
        console.log("where clause", whereClause, x, key1, secondArray, invertFilteredData)
        return unionArray.sort(); //gets the unique values from the filteredData by mapping the passed key and sort the values in ascending order

//        console.log("where clause", x,key1)
      }

    },

    options() {
      const options = {};
      this.dimSelectDpValues.forEach(filter => {
        const vals = this.rowsdata.map(item => item[filter.key])
            .filter(val => val != null && val !== ""); // Filter out null and empty strings

        // Cheap and efficient unique + sort
        options[filter.key] = Array.from(new Set(vals)).sort();

        console.log("Filtered Distinct Options Data", options[filter.key]);
      });
      return options;
    }
  },
  methods: {
    transformValue(value, caseType) {
      if (!value) return value;

      switch(caseType) {
        case 'UpperCase':
          return _.toUpper(value);
        case 'LowerCase':
          return _.toLower(value);
        case 'ProperCase':
          return _.startCase(_.toLower(value));
        case 'SentenceCase':
          return _.upperFirst(_.toLower(value));
        default:
          return value;
      }
    },
    updateInsertValue(event,column,caseType){
      let value = event.target.value;

      // transform based on requiredCase
      value = this.transformValue(value, caseType);

      this.$set(this.rowEdit, column, value);
    },

    updateValue(event, column, caseType) {
      let value = event.target.value;

      // transform based on requiredCase
      value = this.transformValue(value, caseType);

      this.$set(this.rowInsert, column, value);
    },
    autoExpand(e) {
      e.target.style.height = 'auto';
      e.target.style.height = (e.target.scrollHeight) + 'px';
    },
    sortBy: function (key) {
      console.log("The sort Key is ", key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey = key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    date(event, fieldName) {
      let val = event.target.value.this.rowEdit[fieldName] = val;
    },
    handleValidateFunc(fncName, value) {
      console.log("Handle function called with func name", fncName, value);
      if (fncName) {
        this[fncName](value)
      }
    },
    handleIndianPhoneNumberInput(event, fieldName) {
      let phone = event.target.value.replace(/\D/g, '');  // Remove non-digits

      // Ensure first digit is 6-9
      if (phone.length > 0 && !['6', '7', '8', '9'].includes(phone[0])) {
        phone = phone.substring(1);  // Remove invalid starting digit
      }

      phone = phone.substring(0, 10);  // Limit to 10 digits
      this.rowEdit[fieldName] = phone;
    },
    handleNumberInput(event, fieldName) {
      // Allow only numbers
      const value = event.target.value.replace(/[^0-9]/g, '');
      this.rowEdit[fieldName] = value;
      this.$forceUpdate(); // Ensure Vue updates the model
    },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
    // sendEmail: function () {
    //   this.$loadScript("https://smtpjs.com/v3/smtp.js")
    //       .then(() => {
    //         window.Email.send({
    //           Host: "mail.compegence.com",
    //           Username: "muin.shariff@compegence.com",
    //           Password: "Mu!nYEs#%76@shineS",
    //           To: 'abdur.rahman@compegence.com,muin.shariff@compegence.com',
    //           From: "muin.shariff@compegence.com",
    //           Subject: "Request:MDM Approval",
    //           Body: "Please check the Approval window for a new record addition. Validate and Approve.",
    //         }).then(
    //             alert("mail sent successfully")
    //         )
    //       })
    // },

    // ValidateMFR: function (value) {
    //
    //   let txtmfrCode = document.getElementById("txtmfrCode");
    //   let lblmfrCode = document.getElementById("lblmfrCode")
    //   console.log("Entered validate MFR code", txtmfrCode.value)
    //   let regex = /([A-Z]){2}([0-9]){4}$/;
    //   if (regex.test(value.toUpperCase())) {
    //     lblmfrCode.style.visibility = "hidden";
    //     return true;
    //   } else {
    //     lblmfrCode.style.visibility = "visible";
    //     return false;
    //   }
    // },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns = []
        setTimeout(() => {
          if (from.matched.some(record => record.meta.requiresMdmConfig)) {
            $this.loadReportConfig()
          }
        }, 300)

      })
    },
    //Show Edit Input Field
    edit: function (syspk) {
      console.log('Entered into edit function', syspk);
      this.showInputfield = true;
      this.editableId = syspk;
      const rowToEdit = this.filteredItems.find(row => row.syspk === syspk);

      // Create a deep copy of the row
      this.rowInsert = _.cloneDeep(rowToEdit);
      console.log("Processed row for editing:", this.rowInsert);
    },
    //Show Row
    showRow: function (syspk) {
      console.log('Entered into add function', syspk)
      this.rowEdit = []
      this.showInput = true
      this.savetableId = syspk

    },
    //High Light Selected Row
    toggle(syspk) {
      /* const index = this.opened.indexOf(id)*/
      this.opened.push(syspk)
    },
    show: function () {
      this.$modal.show('hello-world')
    },
    hide: function () {
      this.$modal.hide('hello-world')
    },
    //Hide Add record or save record
    hideR: function (syspk) {
      if (this.savetableId == syspk) {
        this.savetableId = null
        this.editableId = null
      } else {
        this.savetableId = syspk
        this.editableId = syspk
      }
      this.showInputfield = false
      this.rowEdit = []
      this.rowInsert = []
    },
    validateEditRow: function (row) {
      this.rowd = row
      console.log("Entered validate Edit function", row)
      this.$refs["validate-update-row-box"].show();
    },
    validateInsertRow: function (row) {
      // Check for mandatory fields
      let hasEmptyMandatoryFields = false;
      const mandatoryFields = [];

      this.columns.forEach((col, index) => {
        const columnKey = this.Rcolumns[index];
        if (this.columnsInfo[index]['fieldIsNullable'] === 'N' && !row[columnKey] && col !== 'S.No') {
          hasEmptyMandatoryFields = true;
          mandatoryFields.push(col);
        }
      });

      if (hasEmptyMandatoryFields) {
        // Show error message instead of modal
        this.$bvToast.toast(`Please fill all mandatory fields: ${mandatoryFields.join(', ')}`, {
          title: 'Validation Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-center'
        });
        return;
      }

      // Create an object with all column keys and their values
      const rowData = {};

      // Loop through all columns and collect available values
      this.columns.forEach((col, index) => {
        const columnKey = this.Rcolumns[index];
        console.log("columnKey", columnKey);
        // Skip if column is 'syspk'
        if (columnKey !== 'syspk') {
          // Always include the key, use null for missing values
          rowData[columnKey] = row[columnKey] !== undefined ? row[columnKey] : '';
        }
      });

// Store the filtered data
      this.rowdIns = rowData;

      console.log("Filtered row data with key-value pairs:", rowData);
      console.log("Entered validate insert function", row.c_name);

      // Show the validation modal only if all mandatory fields are filled
      this.$refs["validate-insert-row-box"].show();

      // If you need to return the data for further processing
      return rowData;
    },
    updateRecord: function () {
      let updObj = Object.assign({}, this.rowInsert)
      console.log("check the type of update Record", updObj, this.rowInsert)
      axios.post('/api/mdm-form-update/' + this.$route.params.submenuId, updObj, {
        headers: {
          'info-params': JSON.stringify({
            menuId: this.$route.params.menuId,
            submenuId: this.$route.params.submenuId
          }),
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log("Entered mdm-form-update API", res)
        this.loadReportConfig()
        this.formMessage = "Record Updated Successfully"
        this.$refs["success-box"].show();
        this.showInputfield = false
        this.editableId = null
        this.savetableId = null
        this.rowInsert = [];
      })
          .catch(err => {
            console.log("Error in mdm-form-inser API", err)
            this.$bvToast.toast(`Error in calling an API`, {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-center'
            });
          })

      console.log("Entered validate update function", this.rowInsert)

    },
    insertRecord: function () {
      this.columns.forEach((col, index) => {
        if (this.columnsInfo[index]['fieldValidationType'] === 'date') {
          const fieldName = this.Rcolumns[index];

          // Convert date string to Date object if it exists
          if (this.rowdIns[fieldName]) {
            // Assuming date is stored in DD/MM/YYYY format
            const dateParts = this.rowdIns[fieldName].split('/');
            if (dateParts.length === 3) {
              const day = parseInt(dateParts[0], 10);
              const month = parseInt(dateParts[1], 10) - 1; // months are 0-indexed
              const year = parseInt(dateParts[2], 10);

              // Create date without time portion (sets to local midnight)
              const dateObj = new Date(year, month, day);
              this.rowInsert[fieldName] = dateObj;

              console.log("Formatted date:", this.rowInsert[fieldName]);
              // }
            }
          }
        }
      });
      let insObj = Object.assign({}, this.rowdIns)
      console.log("Entered validate insert function", insObj)
      axios.post('/api/mdm-form-insert/' + this.$route.params.submenuId, insObj, {
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }
      ).then(res => {
        console.log("Entered mdm-form-insert API", res)
        // Find email field and its value
        let recipientEmail = null;
        this.columns.forEach((col, index) => {
          if (this.columnsInfo[index]['fieldValidationType'] === 'email') {
            const fieldName = this.Rcolumns[index];
            if (this.rowdIns[fieldName]) {
              recipientEmail = this.rowdIns[fieldName];
            }
          }
        });

        // Only send email if we found an email field with a value
        if (recipientEmail) {
          const data={
            email:recipientEmail,
            purpose:"mdm-report"
          }
          axios.post('/api/send-mail',data,{
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }).then(resp=>{
                if(resp.status===200){
                  // Success toast
                  this.$bvToast.toast('Email sent successfully!', {
                    title: 'Success',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 5000,
                    toaster: 'b-toaster-top-center'
                  });
                }
              }
          ).catch(error => {
            // Error toast
            const errorMessage = error.response?.data?.error || 'Failed to send email';
            this.$bvToast.toast(errorMessage, {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-center'
            });

            console.error('Email sending error:', error);
          })
        }

        this.savetableId = null;
        this.showInputfield = false;
        this.showInput = false;
        this.formMessage = "Record Added Successfully"
        this.$refs["success-box"].show();
        this.rowEdit = [];
        this.loadReportConfig()
      })
          .catch(err => {
            console.log("Error in mdm-form-insert API", err)

            // Default error message
            let errorMessage = 'An error occurred while processing your request';
            let isDuplicateKeyError = false;

            // Check for specific error types
            if (err.response && err.response.data) {
              const errorData = err.response.data;

              // Use server-provided message if available
              if (errorData.message) {
                errorMessage = errorData.message;
              }
              // Handle duplicate key error
              // Check for duplicate key error
              if (errorData.errorType === 'DUPLICATE_KEY') {
                isDuplicateKeyError = true;
                if (errorData.columns && errorData.columns.length > 0) {
                  const friendlyNames = errorData.columns.map(col => col);
                  errorMessage = `A record with <span style="color: #ff6b6b; font-weight: bold;">${friendlyNames.join('</span>, <span style="color: #ff6b6b; font-weight: bold;">')}</span>
                matching <span style="color: #4ecdc4; font-weight: bold;">${errorData.duplicateValue}</span>
                already exists in the system.`;
                }
              }
              // Use the server-provided message if available
              else if (err.response.data.message) {
                errorMessage = err.response.data.message;
              }
            } else if (err.message) {
              errorMessage = err.message;
            }

            // Handle different error types
            if (isDuplicateKeyError) {
              // Show modal for duplicate key errors
              this.title = errorMessage;
              this.showErrorModal = true;
            } else {
              // Show toast for other errors
              this.$bvToast.toast(errorMessage, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
                toaster: 'b-toaster-top-center'
              });
            }
            // Log the full error for debugging
            console.error('Full error details:', err);
          })
      // console.log("Entered validate insert function", this.rowdIns)

    },
    fetchListbox: function (sql) {
      var listboxData = []
      axios.post('/api/fetchDataWithParam/' + sql + '/Any', {}).then(
          res => {
            listboxData = res.data.rowsdata


          },
          err => {
            console.log('Error Fetching data', err)
          }
      )
      console.log("response of listbox SQL", listboxData)
      return listboxData;

    },
    GSTINValidate: function (gstinNum) {
      let url = 'https://sheet.gstincheck.co.in/check/' + '0739c4914d38e88bcb6346fa805800b4' + '/' + gstinNum
      axios.get(url)
          .then(res => {
            this.result = res
            console.log("results", this.result)
            this.message = res.data.message
            this.name = res.data.data.tradeNam
          }, err => {
            console.log('Error in record', err)
          })
    },
    loadReportConfig: async function () {
      console.info('loading summary', this.$route.params.submenuId)
      let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      //Get Request
      axios.get('/api/formConfigColumn/' + menuParam)
          //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
          .then(res => {
            this.apiData = res.data
            this.rowsdata = this.apiData.rowsData
            this.formTitle = this.apiData.columns[0].formName
            this.columnsInfo = this.apiData.columns
            this.columns = this.apiData.columns.map(function (el) {
              return el.formFieldDisplay;
            })
            this.filters = this.apiData.columns
                .filter(col => col.filterFlag === true)
                .map(col => ({
                  displayName: col.formFieldDisplay,
                  key: col.formColumnName
                }));       // Then map to get the display names
            console.log('ReportConfigRes', this.apiData, this.apiData.columns)
            var rowsDataKeys = Object.keys(this.rowsdata[0])
            this.rowsDataDimKeys = rowsDataKeys
            this.dimSelectDpValues = this.filters
            console.log('Dimension variables Keys', this.rowsDataDimKeys)
            console.log('Data for Report', this.rowsdata)
            console.log('Dimension variables Keys', this.dimSelectDpValues)
            //console.log('Report Title',this.apiData.columns[0].repName)
            //console.log('Report headers',this.nameArray)
            const sorted = this.rowsdata.map(person => {
              let rtn = {}
              this.rowsDataDimKeys.forEach(key => {
                rtn[key] = person[key]
              })
              return rtn
            })
            this.example = [...new Set(sorted.map(JSON.stringify))].map(JSON.parse)
            //console.log("Distinct values of report data",sorted)

            // Listbox Data call
            let selectOnlyFields = this.columnsInfo.filter(k => k.inputFieldType == 'Select Only')
            selectOnlyFields.forEach(s => {
              console.log("select listbox data", s.fieldSelectListboxSql)
              axios.post('/api/fetchDataWithParam/' + s.fieldSelectListboxSql + '/Any', {}).then(
                  res => {
                    let values = res.data.rowsData.map(item => item[s.formColumnName] ?? '')
                    console.log("select listbox data", s.fieldSelectListboxSql, res.data.rowsData)
                    this.listboxData[s.formColumnName] = values
                    if (s.fieldSelectListboxSql == 'SQL731') {
                      this.mfgNameList = res.data.rowsData
                      console.log("Mfg names list", this.mfgNameList, this.mfgNameList.filter(f => f.c_mfac_code == 'MF0001'))
                    }
                    if (s.fieldSelectListboxSql == 'SQL732') {
                      this.brandNameList = res.data.rowsData
                      console.log("brand names list", this.brandNameList)
                    }

                  }).catch(e=>{
                    console.log("error",e);
                  })
            })
            console.log("select only fields", this.listboxData);

          }, err => {
            console.log('Error Fetching data', err)
          })


      /*               //Get Request
                      axios.get('/api/reportConfigColumn/'+ menuParam +'/G01')
                      .then(res => {
                      this.drilldowndata = res.data
                      var columns = this.drilldowndata.columns
                      //var rowsdata = this.drilldowndata.rowsdata
                      console.log("API Response",this.drilldowndata)
                      var drilldownlevels = [...new Set(columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
                      var levelColumns = []
                      var headerColumns = []
                      for (var i=1; i<=drilldownlevels.length; i++)
                      {
                          var value ='level'+i
                          levelColumns[i] = columns.filter( ind => ind.drilldownLevel ==value)
                          headerColumns[i] = levelColumns[i].map(function (el) { return el.headerColumnDisplay;})
                      }
                      //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
                      console.log("Drilldown data level1",headerColumns[1])
                      console.log("Drilldown data level2",headerColumns[2])
                      console.log("Drilldown data level3",headerColumns[3])

                      }, err => {
                      console.log('Error Fetching data', err)
                      })

                     //Post Request
                     const params = new URLSearchParams();
                     params.append('param1', 'value1');
                     params.append('param2', 'value2');
                     axios.post('/api/testparams', params)
                     //axios.post('/api/reportConfigColumn/'+ menuParam +'/G01')
                     .then(res => {
                      this.string = res.data
                     //var columns = this.drilldowndata.columns
                     //var rowsdata = this.drilldowndata.rowsdata
                     console.log("Post API Called",this.string)
                     }, err => {
                         console.log('Error Fetching data', err)
                         })
                 }*/
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      console.log("menuDetails", menuDetails);
      await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success",this.$store.state.deviceType)
    }
  }
}
</script>
<style scope>

th {
  font-size: 12px;
}

/*
.grid-container {
  overflow-y: auto;
  height: 500px;
}*/

td {
  text-align: left;
}

.error {
  color: Red;
  visibility: hidden;
}

/* Base cell styling */
.multi-line-cell {
  white-space: normal !important;
  word-wrap: break-word !important;
}

/* Default width (when not textarea) */
.multi-line-cell {
  max-width: 150px;
}

/* Wider width for textarea fields */
.multi-line-cell.textarea-cell {
  max-width: 500px;
}

.card-body {
  padding: 1px;
}

.custom-padding{
  padding: 4px 6px;
}


</style>